<template>
  <div>
    <div
      v-if="mobileSplit"
      class="publishing-text publishing-text-mobile my-5"
      :class="textClass"
    >
      <span
        v-for="(line, index) in lines"
        :key="`line-${index}`"
        :class="{ 'mt-3': index }"
      >
        {{ line }}
      </span>
    </div>
    <div
      class="publishing-text publishing-text-desktop my-5 container"
      :class="[textClass, mobileSplit && 'mobile-split']"
    >
      <span />
      <span class="mx-2">{{ desktopText }}</span>
      <span />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleWithBackground',

  props: {
    lines: {
      type: Array,
      default: () => []
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'danger'].includes(value)
    },
    direction: {
      type: String,
      default: 'right',
      validator: (value) => ['right', 'left'].includes(value)
    },
    mobileSplit: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    desktopText() {
      return this.lines.join(' ');
    },
    textClass() {
      return {
        'text-right': this.direction === 'right',
        'text-left': this.direction === 'left',
        'text-primary': this.variant === 'primary',
        'text-secondary': this.variant === 'secondary',
        'text-danger': this.variant === 'danger'
      };
    }
  },

  methods: {
    loadImage() {
      if (!this.isError) {
        this.isError = true;
        document.getElementById('mainImg').src = this.imgLink;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.publishing-text {
  font-family: 'PPRader-Bold', sans-serif;
  font-size: 25px;
  line-height: 1.2;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  padding: 0;

  span {
    width: fit-content;
    padding: 16px;
    border-radius: 16px;
  }

  &-mobile {
    flex-direction: column;

    &.text-right {
      span {
        &:first-child {
          border-radius: 16px 0 0 16px;
          margin-left: auto;
        }
      }
    }

    &.text-left {
      span {
        &:last-child {
          border-radius: 16px 0 0 16px;
          margin-left: auto;
        }
      }
    }

    span {
      border-radius: 0 16px 16px 0;
    }

    @media (min-width: $screen-width-md) {
      display: none;
    }
  }

  &-desktop {
    justify-content: center;

    span {
      border-radius: 16px;

      &:first-child {
        border-radius: 0 16px 16px 0;
        flex-grow: 1;
        background-color: $dark-secondary-color;
        transform: translateY(-10px);
      }

      &:last-child {
        border-radius: 16px 0 0 16px;
        flex-grow: 1;
        background-color: $dark-secondary-color;
        transform: translateY(10px);
      }
    }

    &.mobile-split {
      @media (max-width: $screen-width-md - 1px) {
        display: none;
      }

      @media (max-width: $screen-width-lg) {
        span {
          &:first-child,
          &:last-child {
            display: none;
          }
        }
      }
    }
  }
}

.text {
  &-primary {
    span {
      background-color: $primary-color;
      color: $black-color !important;
    }
  }

  &-secondary {
    span {
      background-color: $secondary-color;
      color: $white-color !important;
    }
  }

  &-danger {
    span {
      background-color: $color-magenta;
      color: $white-color !important;
    }
  }
}
</style>
